import { DatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";

export type TruxSimpleDateFieldProps = {
  value?: string,
  onChange: (a: string | undefined) => void,
  label?: string,
  disabled?: boolean,
  limitWidth?: boolean
}

export default function TruxSimpleDateField({ value, onChange, disabled = false, label, limitWidth = true }: TruxSimpleDateFieldProps) {
  return <DatePicker
    label={label}
    value={!value ? null : dayjs(value as any)}
    onChange={(date: Dayjs | null) => { onChange(date?.format("YYYY-MM-DD")) }}
    disabled={disabled}
    slotProps={{
      textField: {
        fullWidth: true,
        size: "small"
      },
    }}
    sx={{
      maxWidth: limitWidth ? { md: 180 } : undefined,
      width: "100%"
    }}
  />
}